<div class="detail-perimeter">
  <div class="data-chart mb-6">
    <div
      class="d-flex flex-wrap justify-content-between align-items-center mb-3 ms-xxl-6 me-xxl-4"
    >
      <h1 class="fs-2 me-3 my-1">
        <ng-container
          *appSkeletonLoader="
            loading;
            style: { height: '2.5rem', width: '10rem' }
          "
        >
          <span i18n="@@patient_evaluationPerimeter_title"
            >Walking perimeter</span
          >
        </ng-container>
      </h1>
      <form [formGroup]="dateRangeForm">
        <div class="data-chart__filter row align-items-center my-1">
          <div class="col-auto pe-0">
            <ng-container
              *appSkeletonLoader="
                loading;
                style: { height: '2.5rem', width: '1.8rem' }
              "
            >
              <label
                for="startDate"
                class="col-form-label fw-semi-bold text-gray-70"
                i18n="@@patient_evaluation_fromLabel"
                >From</label
              >
            </ng-container>
          </div>
          <div class="col-auto">
            <div class="form-group">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '2.5rem', width: '8rem' }
                "
              >
                <div
                  class="input-group"
                  ngbDropdown
                  #dropdownStartDate="ngbDropdown"
                  autoClose="outside"
                  placement="bottom-right"
                >
                  <input
                    type="text"
                    class="form-control form-control--monthpicker bg-white"
                    placeholder="MM/AAAA"
                    i18n-placeholder="@@patient_evaluation_fromPlaceholder"
                    name="startDate"
                    formControlName="startDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('startDate').invalid &&
                        !dateRangeForm.get('startDate').pristine
                    }"
                  />
                  <button
                    type="button"
                    class="dropdown-toggle-split"
                    id="dropdownStartDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('startDate').invalid &&
                        !dateRangeForm.get('startDate').pristine
                    }"
                    ngbDropdownToggle
                  >
                    <img
                      src="assets/icons/icon_calendar.svg"
                      class="img-fluid"
                      alt="calendar"
                    />
                  </button>
                  <div
                    ngbDropdownMenu
                    class="p-0"
                    aria-labelledby="dropdownStartDate"
                  >
                    <app-monthpicker
                      (selected)="
                        changeDateRange($event, 'startDate');
                        dropdownStartDate.close()
                      "
                      [year]="getDateYear('startDate')"
                      [month]="getDateMonth('startDate')"
                    ></app-monthpicker>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-auto px-0">
            <ng-container
              *appSkeletonLoader="
                loading;
                style: { height: '2.5rem', width: '1.8rem' }
              "
            >
              <label
                for="endDate"
                class="col-form-label fw-semi-bold text-gray-70"
                i18n="@@patient_evaluation_toLabel"
                >to</label
              >
            </ng-container>
          </div>
          <div class="col-auto">
            <div class="form-group">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '2.5rem', width: '7rem' }
                "
              >
                <div
                  class="input-group"
                  ngbDropdown
                  #dropdownEndDate="ngbDropdown"
                  autoClose="outside"
                  placement="bottom-right"
                >
                  <input
                    class="form-control form-control--monthpicker bg-white"
                    placeholder="MM/AAAA"
                    i18n-placeholder="@@patient_evaluation_toPlaceholder"
                    id="endDate"
                    formControlName="endDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('endDate').invalid &&
                        !dateRangeForm.get('endDate').pristine
                    }"
                  />
                  <button
                    type="button"
                    class="dropdown-toggle-split"
                    id="dropdownEndDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('endDate').invalid &&
                        !dateRangeForm.get('endDate').pristine
                    }"
                    ngbDropdownToggle
                  >
                    <img
                      src="assets/icons/icon_calendar.svg"
                      class="img-fluid"
                      alt="icon"
                    />
                  </button>
                  <div
                    ngbDropdownMenu
                    class="p-0"
                    aria-labelledby="dropdownEndDate"
                  >
                    <app-monthpicker
                      (selected)="
                        changeDateRange($event, 'endDate');
                        dropdownEndDate.close()
                      "
                      [year]="getDateYear('endDate')"
                      [month]="getDateMonth('endDate')"
                    ></app-monthpicker>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </form>
    </div>
    <app-chart
      [loading]="loadingChart"
      [chartDatasets]="datasets"
      [chartXLabels]="xLabels"
      [chartDatasetFilter]="datasetFilter"
      (toggledFeatureDisplay)="updateChartDescriptionFeature($event)"
      (toggledFilterDisplay)="updateChartDescriptionFilter($event)"
    ></app-chart>
  </div>
  <div class="py-4">
    <ngb-accordion #a="ngbAccordion" activeIds="desc_test, desc_situation">
      <ngb-panel id="desc_test">
        <ng-template ngbPanelHeader>
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="m-0">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '1.6rem', width: '10rem' }
                "
              >
                <span i18n="@@patient_evaluation_evaluationDescriptionTitle"
                  >Evaluation description</span
                >
              </ng-container>
            </h3>
            <div>
              <ng-container
                *appSkeletonLoader="
                  loading;
                  type: 'circle';
                  style: { height: '2.6rem', width: '2.6rem' }
                "
              >
                <button ngbPanelToggle class="btn btn-link p-0">
                  <img
                    [src]="
                      a.isExpanded('desc_test')
                        ? 'assets/icons/icon-dropdown-close.svg'
                        : 'assets/icons/icon-dropdown-open.svg'
                    "
                    alt="icon"
                  />
                </button>
              </ng-container>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="content-card">
            <ng-container
              *appSkeletonLoader="loading; style: { height: '12rem' }"
            >
              <div>
                <u i18n="@@patient_evaluation_evaluationDescriptionContentTitle"
                  >Principe de l’évaluation :</u
                >
                <br />
                <p
                  i18n="
                    @@patient_evaluationPerimeter_evaluationDescriptionContentP1"
                >
                  Ce test consiste à calculer le périmètre de marche des
                  patients jusqu'à une distance maximale de 1 km. Ce test est
                  basé sur le test Timed 25-Foot Walk (T25-FW).<br />Les
                  patients ont pour consignes de marcher à leur rythme habituel
                  en toute sécurité (sans courir).<br />La durée du test
                  s'arrête en tout cas après 30 minutes.
                </p>
              </div>
              <div>
                <u
                  i18n="
                    @@patient_evaluation_evaluationDescriptionConditionTitle"
                  >Condition de validité du test :</u
                >
                <br />
                <span
                  i18n="
                    @@patient_evaluationPerimeter_evaluationDescriptionConditionContent"
                  >Le test sera considéré comme valide si le patient :
                </span>
                <ul class="list">
                  <li
                    i18n="
                      @@patient_evaluationPerimeter_evaluationDescriptionConditionContentLi1"
                  >
                    atteint 1 km
                  </li>
                  <li
                    i18n="
                      @@patient_evaluationPerimeter_evaluationDescriptionConditionContentLi2"
                  >
                    atteint le temps limite de 30 minutes
                  </li>
                  <li
                    i18n="
                      @@patient_evaluationPerimeter_evaluationDescriptionConditionContentLi3"
                  >
                    s'arrête volontairement parce qu'il n’est pas capable de
                    continuer
                  </li>
                </ul>
              </div>
              <div>
                <u i18n="@@patient_evaluation_evaluationDescriptionResultTitle"
                  >Résultats :</u
                ><br />
                <span
                  i18n="
                    @@patient_evaluationPerimeter_evaluationDescriptionResultContent"
                  >Les données recueillies permettent de fournir les
                  informations suivantes :
                </span>
                <ul class="list">
                  <li
                    i18n="
                      @@patient_evaluationPerimeter_evaluationDescriptionResultLi1"
                  >
                    Périmètre (en mètres)
                  </li>
                  <li
                    i18n="
                      @@patient_evaluationPerimeter_evaluationDescriptionResultLi2"
                  >
                    Vitesse moyenne (en m/s)
                  </li>
                  <li
                    i18n="
                      @@patient_evaluationPerimeter_evaluationDescriptionResultLi3"
                  >
                    Temps total de marche (en min)
                  </li>
                </ul>
              </div>
            </ng-container>
          </div>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="desc_situation">
        <ng-template ngbPanelHeader let-opened="opened">
          <div
            class="d-flex align-items-center justify-content-between line-top"
          >
            <h3 class="m-0">
              <ng-container
                *appSkeletonLoader="
                  loadingChart;
                  style: { height: '1.6rem', width: '10rem' }
                "
              >
                <span i18n="@@patient_evaluation_situationDescriptionTitle"
                  >Situation description</span
                >
              </ng-container>
            </h3>
            <div>
              <ng-container
                *appSkeletonLoader="
                  loadingChart;
                  type: 'circle';
                  style: { height: '2.6rem', width: '2.6rem' }
                "
              >
                <button ngbPanelToggle class="btn btn-link p-0">
                  <img
                    [src]="
                      a.isExpanded('desc_situation')
                        ? 'assets/icons/icon-dropdown-close.svg'
                        : 'assets/icons/icon-dropdown-open.svg'
                    "
                    alt="icon"
                  />
                </button>
              </ng-container>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="content-card">
            <ng-container
              *appSkeletonLoader="loadingChart; style: { height: '12rem' }"
            >
              <app-chart-description
                [startDate]="dateRangeForm.get('startDate').value"
                [endDate]="dateRangeForm.get('endDate').value"
                [patient]="patientProfile"
                [xLabels]="xLabels"
                [chartDescription]="chartDescription"
              ></app-chart-description>
            </ng-container>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>
